"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _react = _interopRequireDefault(require("react"));
var _Label = require("b2b-components/theme/components/Form/Label");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Radio.scss");
var Radio = function Radio(_ref) {
  var className = _ref.className,
    label = _ref.label,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    _ref$isChecked = _ref.isChecked,
    isChecked = _ref$isChecked === void 0 ? false : _ref$isChecked,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var Label = Radio.Label;
  var rootClassName = (0, _classnames["default"])('cds-Radio', className);
  return /*#__PURE__*/_react["default"].createElement(Label, {
    className: rootClassName,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("input", {
    checked: isChecked,
    className: "cds-Radio-Input",
    disabled: isDisabled,
    onChange: onChange,
    type: "radio"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Radio-Field"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-Radio-Value"
  }, label));
};
exports.Radio = Radio;
Radio.Label = _Label.Label;